import "./src/styles/theme.scss"
import "./src/styles/global.scss"

import React from "react"
import ThemeProvider from "./src/components/ThemeProvider"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
)
